<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
      <search-form-template
         ref="storeTemplate"
        :searchOptions="searchOptions"
        :toolConfig="toolConfig"
         @searchSubmit="searchSubmit"
        @clear="clearSearch"
        @btnCommon="btnCommon"
      ></search-form-template>
      <div class="centerBack">
        <div class="echartsArea">
          <echarts-template
            class="charts-box"
            ref="reportStatistics"
            :picOption="reportStatistics"
          >
          </echarts-template>
        </div>
         <list-template ref="total" :tableOptions="storeReportTable" :tableData="totalList">
          </list-template>
      </div>
  </div>
</template>

<script>
import api from "@/config/api";
import searchFormTemplate from "@/components/template/searchFormTemplate";
import listTemplate from "@/components/template/listTemplate";
import echartsTemplate from "@/components/controls/echarts";
import {reportStatistics} from "@/page/home/options/reportEcharts";
import userPower from "@/mixin/userPower";

export default {
   mixins: [userPower],
  components: { searchFormTemplate, listTemplate, echartsTemplate },
  data() {
     let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
     let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
     let defaultParam = {stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
    return {
      type:'',
      totalList:[],
      param: defaultParam,
      reportStatistics,
      title: "",
      indexShow: false,
      searchOptions: {
        simple: [
          {
            label: '门店名称',
            type: 'select',
            data:[],
            prop: 'storeIds',
            multiple: true,
            url:api.system.seStore
            },
        ],
        complex: [
         {
            label: "选择日期",
            prop: "CreateDttm",
            type: "datetimeRange",
            dateType: "datetime",
            span: 12,
          },
          {
            prop: 'dateType',
            type: 'radio',
            span: 12,
            data: [{label: '按天', value: 20}, {label: '按周', value: 40}, {label: '按月', value: 30}],
            change:this.timeChoose
          },
        ]
      },
      storeReportTable: {
        indexShow: true, //是否显示索引
        columns: [
          {
            label: "店铺",
            prop: "storeName",
            width: "280",
            align: "center",
          },
          {
            label: "新增会员数",
            prop: "memberIncreaseNum",
            width: "240",
            align: "center",
          },
          {
            label: "下单人数",
            prop: "memberChangeNum",
            width: "240",
            align: "center",
          },
          {
            label: "会员转化率",
            prop: "memberChangeRate",
            width: "240",
            align: "center",
          },
          {
            label: "日期",
            prop: "dateTime",
            width: "260",
            align: "center",
          },
        ],
      },
      toolConfig: [
        {
          label: "导出",
          code: "export",
          callback:this.exportData
        },
      ],
    };
  },
  created() {
    this.setStore(this.searchOptions.simple);
    this.getData(this.param);
    this.getMemberList(this.param)
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    getData(param) {
       let params={dateType:this.type||20}
       let $params = Object.assign({},params,param);
       this.$axios.fetchPost(api.report.memberAddEcharts,$params).then(data=>{
        if(data.code===200){
              this.reportStatistics.charsOption.title.text ="";
              this.reportStatistics.charsOption.title.top=0;
              this.reportStatistics.charsOption.title.left=0;
              this.reportStatistics.charsOption.xAxis[0].data =
              data.data.dateTime;
            this.reportStatistics.charsOption.series[0].data =
              data.data.memberIncreaseNum;
            this.reportStatistics.charsOption.series[1].data =
              data.data.memberChangeNum;
            this.reportStatistics.charsOption.series[2].data =
              data.data.memberChangeRate;
        }
         this.$nextTick(() => {
        this.$refs.reportStatistics.drawpic();
      });
      })
    },
    getMemberList(param){
        let params={dateType:this.type||20}
        let $params = Object.assign({},params,param);
         this.$axios.fetchPost(api.report.memberAddList,$params).then(data=>{
            this.totalList = data.data;
         })
    },
    timeChoose(data){
      this.type = data.dateType;
    },
     btnCommon(btnObj) {
      btnObj.callback && btnObj.callback();
    },
    searchSubmit() {
        const simpleParams = Object.assign({},this.$refs.storeTemplate.getSimpleParams(),this.$refs.storeTemplate.getComplexParams());
        let $param=Object.assign({},this.param,simpleParams)
        console.log($param)
        this.getData($param)
        this.getMemberList($param)
    },
    clearSearch() {
       this.getData(this.param)
       this.getMemberList(this.param)
    },
    exportData(){
      const simpleParams = Object.assign({}, this.$refs.storeTemplate.getSimpleParams(), this.$refs.storeTemplate.getComplexParams());
      let $param = Object.assign({}, this.param, simpleParams, {exportCode: 'memberIncreaseExport'}, {dateType: this.type || 20})
      this.$axios.fetchPost(api.report.memberAddExport, $param).then(data => {
        if (data.code === 200) {
          const elink = document.createElement('a');
          elink.href = data.data;
          elink.click();
          this.loadingExt = false;
          this.$notify({
            type: "success",
            title: '导出操作',
            message: '成功',
            showClose: false,
          });
          // this.$message({message: '导出成功', type: 'success'});
        } else {
          this.$notify({
            type: "error",
            title: '导出操作',
            message: '失败',
            showClose: false,
          });
          // this.$message({message: '导出异常', type: 'error'});
        }
      })
    },
  },
};
</script>

<style scoped>
.page-template .centerBack {
  width: 100%;
  /* height: calc(100vh - 62px); */
  background: #fff;
  border-radius: 8px;
  padding: 25px;
  margin-bottom: 10px;
}

.page-template .echartsArea {
  width: 100%;
  height: 500px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// src/page/report/member/add/Statistics.vue